import {MenuOutlined} from '@ant-design/icons';
import {Button} from 'antd';
import {useEffect, useState} from 'react';
import {NavLink} from 'react-router-dom';

import logo from '../../assets/Images/brown logo.png';

import {DrawerComponent} from './DrawerComponent';

const Navbar = () => {
  const [open, setOpen] = useState(false);

  const [isScrolled, setIsScrolled] = useState(false);

  const showDrawer = () => setOpen(true);
  const closeDrawer = () => setOpen(false);

  // check scroll to decrease height of the navbar
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {setIsScrolled(true);}
      else {setIsScrolled(false);}
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    {name: 'Home', path: '/'},
    {name: 'About', path: '/about'},
    {name: 'Services', path: '/services'},
    {name: 'Gallery', path: '/gallery'},
    {name: 'Careers', path: '/CareerScreen'},
    {name: 'Channel Partners', path: '/channel'},
  ];

  return (
    <div>
      <nav
        className={`z-10 fixed w-full bg-primary-950 font-serif text-black transition-all duration-300 
      ${isScrolled ? 'py-2 shadow-md' : 'py-4'} px-4 md:px-8 lg:px-16`}
      >
        <div className={'flex items-center justify-between max-w-7xl mx-auto w-full'}>
          {/* Logo */}
          <NavLink to={'/'}>       
            <img
              src={logo}
              className={`transition-all duration-300 ${
                isScrolled ? 'w-[70px] h-14' : 'w-[100px] h-20'
              }`}
              alt={'Logo'}
            />       
          </NavLink>

          {/* Desktop Menu */}
          <div className={'hidden lg:flex items-center gap-10'}>
            {navLinks.map((link, index) => (
              <NavLink
                key={index}
                to={link.path}
                className={({isActive}) =>
                  `relative ${isActive ? 'after:w-2/3' : 'after:w-0'}
                after:absolute after:left-0 after:bottom-0 after:h-[1.3px] after:bg-secondary-300 
                after:transition-all after:duration-300 hover:after:w-2/3`
                }
              >
                <span
                  className={`transition-all duration-300 ${
                    isScrolled ? 'text-base' : 'text-lg'
                  }`}
                >
                  {link.name}
                </span>
              </NavLink>
            ))}
            <NavLink to={'/contact-us'}>
              <Button type={'primary'} className={'!bg-secondary-300 !text-white font-serif font-semibold'}>
        Contact Us
              </Button>
            </NavLink>    
          </div>

          {/* Mobile Menu Button */}
          <div className={'lg:hidden flex items-center'}>
            <Button
              type={'text'}
              className={'h-14'}
              icon={<MenuOutlined style={{fontSize: '26px', color: '#3e2c2c'}} />}
              onClick={showDrawer}
            />
          </div>
        </div>

        {/* Drawer for Mobile */}
        <DrawerComponent open={open} closeDrawer={closeDrawer} />
      </nav>
    </div>
  );
};

export default Navbar;
